export enum TransferStatus {
  Initiated = 'initiated',
  Scanned = 'scanned',
  Pending = 'pending',
  Confirmation = 'confirmation',
  Success = 'success',
  Failed = 'failed',
  Canceled = 'canceled',
}
